import { pathwayTestProgression } from '@ispm-client/modules/pathways/store/reducers/pathway-test.reducer';
import { bpmnNodesCurationData } from '@ispm-client/modules/pathways/store/reducers/bpmn-nodes-curation-data.reducer';
import { curationItemId } from '@ispm-client/modules/pathways/store/reducers/curation-item-id.reducer';
import { clinicalTrials } from '@ispm-client/modules/pathways/store/reducers/clinical-trials.reducer';
import { ActionReducer, combineReducers, MetaReducer } from '@ngrx/store';
import { initialState } from '@ispm-client/modules/pathways/store/state';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
import {pathwaysIsPrefetched} from '@ispm/test/store/prefetch-data/prefetch-data.reducers';
import {knowledgeBase} from "@ispm-client/modules/pathways/store/reducers/knowledge-base.reducer";


export const combinedReducers = {
  pathwayTestProgression: pathwayTestProgression,
  bpmnNodesCurationData: bpmnNodesCurationData,
  curationItemId: curationItemId,
  clinicalTrials: clinicalTrials,
  pathwaysIsPrefetched: pathwaysIsPrefetched,
  knowledgeBase: knowledgeBase

};


const pathwaysMetaReducer = combineReducers(combinedReducers, initialState);

export function pathwaysMetaReducerA(state, action) {
  return pathwaysMetaReducer(state, action);
}

export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateReducer];
